import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import VerifiedBadge from '../common/components/VerifiedBadge';
import RequestVerificationModal from './components/RequestVerificationModal';

/**
 * Inject either the verified-status pill, the pending pill, or the "request
 * verification" button into the user's account settings page, depending on
 * the user's current verification state.
 */
export default function addVerificationRequestButton() {
  extend('flarum/forum/components/SettingsPage', 'accountItems', function (items) {
    const user = app.session.user;
    if (!user) return;
    if (user.isVerified && user.isVerified()) {
      items.add('verifiedStatus', m("button", {
        type: "button",
        className: "Button VerifiedSettings-pill VerifiedSettings-pill--verified",
        disabled: true
      }, m("span", {
        className: "Button-icon VerifiedSettings-pill-icon"
      }, m(VerifiedBadge, {
        user: user,
        plain: true
      })), m("span", {
        className: "Button-label"
      }, app.translator.trans('ramon-verified.forum.settings.verified_label'))), 80);
      return;
    }
    if (user.hasPendingVerificationRequest && user.hasPendingVerificationRequest()) {
      items.add('verifiedPending', m("button", {
        type: "button",
        className: "Button VerifiedSettings-pill VerifiedSettings-pill--pending",
        disabled: true
      }, m("i", {
        className: "icon fas fa-hourglass-half Button-icon"
      }), m("span", {
        className: "Button-label"
      }, app.translator.trans('ramon-verified.forum.settings.pending_label'))), 80);
      return;
    }
    if (user.canRequestVerification && user.canRequestVerification()) {
      items.add('verifiedRequest', m("div", {
        className: "Form-group"
      }, m(Button, {
        className: "Button",
        icon: "fas fa-certificate",
        onclick: () => app.modal.show(RequestVerificationModal)
      }, app.translator.trans('ramon-verified.forum.settings.request_button'))), 80);
    }
  });
}